import React from 'react'
import { useFormContext, Controller } from 'react-hook-form'
import payment from 'payment'
import creditCardType from 'credit-card-type'
import formStyles from '../form.module.css'
import styles from './card-number.module.css'
import { formatCardNumber } from './formatter'
import { CARD_TYPES_BASE } from './card-input-constants'
import { getIconBrand } from './card-input-icons'
import iconoTarjeta from '../../../assets/icono-tarjeta.png'

const MAX_INPUT_LEN = 23

export const CardNumber = ({
  name = 'cardNumber',
  label = 'Número de tarjeta',
  helpText = '',
  required = false,
  placeholder = 'Número de tarjeta'
}) => {
  const { control, setError, clearErrors } = useFormContext()

  const handleChange = (field) => (event) => {
    const target = event.target
    const cardNumberLength = target.value.split(' ').join('').length

    const paymentCardType = payment.fns.cardType(target.value)
    const brandKey = paymentCardType && CARD_TYPES_BASE[paymentCardType]
    const cardTypeInfo =
      brandKey && creditCardType.types[brandKey]
        ? creditCardType.getTypeInfo(creditCardType.types[brandKey]) ?? {}
        : {}

    const cardTypeLengths = cardTypeInfo.lengths ?? [16]
    const lastCardTypeLength = cardTypeLengths[cardTypeLengths.length - 1]

    for (const length of cardTypeLengths) {
      if (length === cardNumberLength && payment.fns.validateCardNumber(target.value)) {
        clearErrors(name)
        break
      }

      if (cardNumberLength === lastCardTypeLength) {
        setError(name, {
          type: 'validationError',
          message: 'El número de tarjeta no es válido'
        })
      }
    }

    const digitsOnly = target.value.replace(/\s/g, '')
    field.onChange(digitsOnly)
  }

  return (
    <Controller
      name={name}
      control={control}
      defaultValue=""
      render={({ field, fieldState }) => {
        const paymentCardType = payment.fns.cardType(field.value ?? '')
        const displayValue = formatCardNumber(field.value ?? '')

        return (
          <div className={formStyles.field}>
            <label className={formStyles.label} htmlFor={name}>
              {label}{' '}
              {required && <span className={formStyles.required}>*</span>}
            </label>

            <div
              className={`${formStyles.shell} ${fieldState.error ? styles.shellInvalid : ''}`}
            >
              <span className={formStyles.prefix}>
                <img src={iconoTarjeta} alt="Usuario" height={17} />
              </span>
              <input
                id={name}
                ref={field.ref}
                name={field.name}
                className={formStyles.input}
                type="tel"
                inputMode="numeric"
                autoComplete="cc-number"
                maxLength={MAX_INPUT_LEN}
                placeholder={placeholder}
                value={displayValue}
                onBlur={field.onBlur}
                onChange={handleChange(field)}
              />
              <span className={styles.suffix}>{getIconBrand(paymentCardType, 25)}</span>
            </div>

            {fieldState.error && (
              <p className={formStyles.error}>{fieldState.error.message}</p>
            )}

            {helpText && <p className={formStyles.helpText}>{helpText}</p>}
          </div>
        )
      }}
    />
  )
}
